import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';

const FLEX_BLOCK_TAGS = new Set([
  'section',
  'article',
  'header',
  'footer',
  'nav',
  'aside',
  'main',
  'div',
  'ul',
  'ol',
  'li',
]);

const TABLE_TAGS = new Set([
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
]);

const BLOCK_TAGS = new Set([...FLEX_BLOCK_TAGS, ...TABLE_TAGS]);

/** Mirror RN Web `View` so flex layout props work on semantic HTML tags. */
const WEB_FLEX_DEFAULTS = {
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  minWidth: 0,
};

const WEB_TABLE_DEFAULTS = {
  boxSizing: 'border-box',
};

/**
 * Renders a semantic HTML block on web (`section`, `article`, `header`, …)
 * and a `View` on native. Pair with `Text` `tag` props for heading/body copy.
 */
export default function SemanticBlock({
  tag = 'div',
  style,
  children,
  ...rest
}) {
  const normalized = String(tag || 'div').toLowerCase().trim();
  const useDom = Platform.OS === 'web' && BLOCK_TAGS.has(normalized);

  if (useDom) {
    const flatStyle = StyleSheet.flatten(style);
    const webDefaults = FLEX_BLOCK_TAGS.has(normalized)
      ? WEB_FLEX_DEFAULTS
      : TABLE_TAGS.has(normalized)
        ? WEB_TABLE_DEFAULTS
        : {};
    return React.createElement(normalized, {
      style: { ...webDefaults, ...flatStyle },
      ...rest,
    }, children);
  }

  return (
    <View style={style} {...rest}>
      {children}
    </View>
  );
}
